import jquery from "jquery";
global.$ = jquery;

import {TweenMax, TimelineMax} from "gsap/TweenMax";

import "../libs/p3.min";
import "../libs/p3d.min";

import Main from './core/Main';

const main = new Main(1024, 824);
main.init();